// Platters.js
import React from 'react';
// Importez Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Importez les modules nécessaires (ex: Pagination, Navigation)
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

// Importez les styles Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Platters.css'; // Votre CSS personnalisé

const platters = [
  {
    id: 1,
    title: 'Plateau Découverte',
    description: 'Un assortiment de nos meilleurs fromages traditionnels pour 4 à 6 personnes.',
    image: '/images/g3.jpg',
  },
  {
    id: 2,
    title: 'Plateau Gourmet',
    description: 'Un plateau raffiné avec nos sélections spéciales et quelques douceurs sucrées.',
    image: '/images/g4.jpg',
  },
  {
    id: 3,
    title: 'Plateau Fermier',
    description: 'Des fromages fermiers 100% artisanaux pour un moment authentique.',
    image: '/images/g1.jpg',
  },
  {
    id: 4,
    title: 'Plateau de Saison',
    description: 'Découvrez nos fromages du moment, affinés selon les saisons.',
    image: '/images/g2.jpg', // Exemple d'image supplémentaire
  },
  {
    id: 5,
    title: 'Plateau Apéritif',
    description: 'Parfait pour un apéritif convivial entre amis, facile à partager.',
    image: '/images/g5.jpg', // Exemple d'image supplémentaire
  },
];

function Platters() {
  return (
    <section className="platters-section">
      <h2 className="platters-title">Nos Plateaux de Fromages</h2>
      <Swiper
        // Modules à utiliser (pagination et navigation pour les flèches et points)
        modules={[Pagination, Navigation, Autoplay]}
        spaceBetween={30} // Espace entre les slides
        slidesPerView={1} // Nombre de slides visibles par défaut (mobile)
        loop={true} // Active la boucle infinie
        autoplay={{
          delay: 3500, // Délai entre chaque slide (en ms)
          disableOnInteraction: false, // Ne pas arrêter l'autoplay si l'utilisateur interagit
        }}
        pagination={{ clickable: true }} // Active la pagination cliquable
        navigation={true} // Active les flèches de navigation
        centeredSlides={false} // Les slides ne sont pas centrées par défaut
        breakpoints={{
          // Quand la largeur de l'écran est >= 768px
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          // Quand la largeur de l'écran est >= 1024px
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
        className="mySwiper" // Nom de classe pour styliser le Swiper
      >
        {platters.map((platter) => (
          <SwiperSlide key={platter.id}>
            <div className="platter-card">
              <img src={platter.image} alt={platter.title} className="platter-image" />
              <h3 className="platter-card-title">{platter.title}</h3> {/* Renommé pour éviter conflit */}
              <p className="platter-description">{platter.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Platters;